module.exports = __webpack_public_path__ + "static/img/moveUp.f27ff5dc.png";